// extracted by mini-css-extract-plugin
module.exports = {"mainWindow":"Products_mainWindow__1S836","sectionWrapper":"Products_sectionWrapper__24-7K"};